import { render, staticRenderFns } from "./PT501GTMAddToCart.vue?vue&type=template&id=3df1945c&"
import script from "./PT501GTMAddToCart.vue?vue&type=script&lang=js&"
export * from "./PT501GTMAddToCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports